import { NJ_CERTIFIED_SETTINGS } from "../../types";

const NJCertifiedSettings = (state = {}, action) => {
    if (action.type === NJ_CERTIFIED_SETTINGS) {
        return action.payload;
    };
    return state;
};

export default NJCertifiedSettings;